export class Routesegment {
    features: string;

    id: number;

    layername: string;

    linecolor: string;

    linecolornullval: string;

    lineweight: number;

    projectId: number;
}